import axios from "axios";

/**
 * Shared helper: build URLSearchParams from filters for the given keys, call the endpoint
 */
const fetchAggregate = async (endpoint, filters, paramKeys) => {
  const params = new URLSearchParams();
  paramKeys.forEach((key) => {
    if (filters[key] != null && filters[key] !== "") params.append(key, filters[key]);
  });
  const res = await axios.get(`/api/analytics/aggregate/${endpoint}?${params.toString()}`);
  return res.data;
};

const BASE_KEYS = ["eventId", "eventSlug", "startDate", "endDate"];
const CITY_KEYS = ["cityLat", "cityLng", "cityRadius", "cityPath"];

export const getHeatmapData = (filters = {}) =>
  fetchAggregate("heatmap", filters, [...BASE_KEYS, "keyword", ...CITY_KEYS]);

export const getSearchVolume = (filters = {}) =>
  fetchAggregate("search-volume", filters, [...BASE_KEYS, "groupBy", "keyword", "excludePans", ...CITY_KEYS]);

export const getPopularKeywords = (filters = {}) =>
  fetchAggregate("popular-keywords", filters, [...BASE_KEYS, "limit", "keyword", ...CITY_KEYS]);

export const getTrafficSources = (filters = {}) =>
  fetchAggregate("traffic-sources", filters, [...BASE_KEYS, "limit", ...CITY_KEYS]);

export const getMostClickedRestaurants = (filters = {}) =>
  fetchAggregate("restaurant-clicks", filters, [...BASE_KEYS, "limit", ...CITY_KEYS]);

export const getTotalUniqueVisitors = (filters = {}) =>
  fetchAggregate("total-unique-visitors", filters, [...BASE_KEYS, ...CITY_KEYS]);

export const getUniqueVisitors = (filters = {}) =>
  fetchAggregate("unique-visitors", filters, [...BASE_KEYS, "groupBy", ...CITY_KEYS]);

export const getUniqueVisitorsRolling = (filters = {}) =>
  fetchAggregate("unique-visitors-rolling", filters, [
    ...BASE_KEYS, "window", "granularity", ...CITY_KEYS,
  ]);

export const getEventPerformance = (filters = {}) =>
  fetchAggregate("event-performance", filters, ["startDate", "endDate"]);

export const getCitySummary = (filters = {}) =>
  fetchAggregate("city/summary", filters, [...CITY_KEYS, "startDate", "endDate"]);

export const getEngagementFunnel = (filters = {}) =>
  fetchAggregate("engagement-funnel", filters, [...BASE_KEYS, "restaurantId", "source", ...CITY_KEYS]);

export const getLandingPageDistribution = (filters = {}) =>
  fetchAggregate("landing-pages", filters, [...BASE_KEYS, ...CITY_KEYS]);

export const getLandingPageFunnel = (filters = {}) =>
  fetchAggregate("landing-funnel", filters, [...BASE_KEYS, "landingPath", ...CITY_KEYS]);

export const getSessionFlow = (filters = {}) =>
  fetchAggregate("session-flow", filters, [...BASE_KEYS, "landingPath", ...CITY_KEYS]);

export const getRestaurantOwnerAnalytics = async (restaurantId, filters = {}) => {
  const params = new URLSearchParams();
  ["startDate", "endDate"].forEach((key) => {
    if (filters[key] != null && filters[key] !== "") params.append(key, filters[key]);
  });
  const token = localStorage.getItem("token");
  const res = await axios.get(
    `/api/analytics/restaurant/${restaurantId}?${params.toString()}`,
    { headers: { "x-auth-token": token } }
  );
  return res.data;
};
